import { createCrudSlice, createCrudSelectors } from './CrudRedux'

const hallsSlice = createCrudSlice({
  name: 'halls',
  reducers: {
    watchHallsRequest: (state) => {
      return {...state, fetching: true};
    },
    unwatchHallsRequest: (state) => {
      return {...state, fetching: false};
    },   
  },
})

export const HallsActions = hallsSlice.actions

export const HallsSelectors = { 
    ...createCrudSelectors({ name: 'halls' }), 

     // Selector personalizado para obtener el currentHall
    getCurrent: (state) => state.halls.currentHall
}

export default hallsSlice.reducer
